import {calcDailyBudget} from 'core/DailyBudget';
import {insert} from 'core/MoneyBox';
import {saved} from 'core/LifeCycle';

export function spendSaved(state: CoreState): CoreState {
  const {budget, moneyBox, history} = state;
  const savedAmount = saved(budget, history);

  const newMoneyBox = insert(moneyBox, savedAmount);
  const newDailyBudget = calcDailyBudget(budget, history);

  return {
    ...state,
    moneyBox: newMoneyBox,
    dailyBudget: newDailyBudget,
  };
}
